import { genericCallWithBodyAndResponseDecoded, genericGetWithBody, genericGetWithParameters } from "./Networking"

export async function saveTicket(objTicket) {
  const method = 'POST'
  const apiName = 'Tickets/SaveTickets'

  const response = await genericCallWithBodyAndResponseDecoded(
    method,
    apiName,
    objTicket,
  )
  return response
}

export async function getTicketInfo(ticketNo) {
  try {
    let params = {
      'TicketNo': ticketNo
    }

    let response = await genericGetWithParameters('Tickets/GetByTicketNo', params);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function searchTickets(objCriteria){
    try {
        let response = await genericGetWithBody('Tickets/SearchTickets',objCriteria);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function reverseTicket(ticketNo, comment, user) {
  const model={
    TicketNo: ticketNo,
    ReverseComments: comment,
    ReverseUser: user
  }
  const method = 'POST'
  const apiName = 'Tickets/ReverseTicket'

  const response = await genericCallWithBodyAndResponseDecoded(
    method,
    apiName,
    model,
  )
  return response
}